export default function ({state, commit, dispatch, getters}, value) {
    commit('loading', true);
    dispatch('settings/get', {
        cb: () => {
            commit('loading', false);
            if (value === 'search') {
                if (!state.list.items.length) {
                    dispatch('filter', getters['settings/default'])
                } else {
                    if (state.settings.reset) dispatch('search')
                }
            }
        }
    })
}